import { render, staticRenderFns } from "./lawRegisterOld.vue?vue&type=template&id=e155150e"
import script from "./lawRegisterOld.vue?vue&type=script&lang=js"
export * from "./lawRegisterOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e155150e')) {
      api.createRecord('e155150e', component.options)
    } else {
      api.reload('e155150e', component.options)
    }
    module.hot.accept("./lawRegisterOld.vue?vue&type=template&id=e155150e", function () {
      api.rerender('e155150e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/register/lawRegisterOld.vue"
export default component.exports